<template>
  <div>
    <v-overlay v-show="loader">Cargando </v-overlay>
    <v-form @submit.prevent="checkForm">
      <v-col cols="12" class="pb-0">
        <v-text-field
          v-model="Nombre"
          label="Nombre Categoría de tarifa"
          placeholder="Nombre de categoría"
          :error-messages="errors.nombre ? [errors.nombre] : []"
          outlined
          dense
          required
        ></v-text-field>
      </v-col>

      <v-col cols="12" class="text-right">
        <v-btn color="green" dark type="submit">Guardar</v-btn>
        <v-btn color="red" dark @click="$emit('toggle', false)">Cancelar</v-btn>
      </v-col>
    </v-form>
  </div>
</template>
<script>
import moment from "moment";

export default {
  name: "SubCategoriaForm",
  components: {},
  props: ["edit", "dataEdit"],
  data() {
    return {
      Nombre: "",
      loader: false,
      errors: {},
      Id: "",
    };
  },
  methods: {
    selectDate(arg) {
      this.input_date = moment(arg);
      if (this.input_date > this.input_date_final) {
        this.input_date_final = moment(arg);
      }
    },
    selectDateFinal(arg) {
      this.input_date_final = moment(arg);
    },
    checkForm: function (e) {
      e.preventDefault();
      let valid = true;

      this.errors = [];

      if (!this.Nombre) {
        this.errors.nombre = "El nombre de la categoría es obligatorio";
        valid = false;
      } else {
        this.errors.nombre = false;
      }

      if (valid) {
        let doAction = "CREATE";
        if (this.edit) {
          doAction = "EDIT";
        }
        this.$emit("successData", this.$data, doAction);
      }
    },
  },
  computed: {
    disableDates() {
      return { to: new Date(this.input_date) };
    },
  },
  watch: {},
  beforeMount: function () {},
  mounted() {
    //this.getCategories();
    this.loader = false;
    if (this.edit) {
      this.Id = this.dataEdit.id;
      this.Nombre = this.dataEdit.Nombre;
    }
  },
};
</script>
